import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ShoppingBagIcon, XIcon } from 'lucide-react';
const buyers = [{
  name: 'María G.',
  city: 'Miami, FL'
}, {
  name: 'Carlos R.',
  city: 'Houston, TX'
}, {
  name: 'Ana L.',
  city: 'Los Angeles, CA'
}, {
  name: 'Pedro M.',
  city: 'Chicago, IL'
}, {
  name: 'Laura S.',
  city: 'New York, NY'
}, {
  name: 'Jorge D.',
  city: 'Dallas, TX'
}, {
  name: 'Rosa P.',
  city: 'Phoenix, AZ'
}, {
  name: 'Miguel A.',
  city: 'San Antonio, TX'
}, {
  name: 'Carmen V.',
  city: 'Orlando, FL'
}, {
  name: 'Luis H.',
  city: 'Atlanta, GA'
}];
function getRandomBuyer() {
  return buyers[Math.floor(Math.random() * buyers.length)];
}
function getRandomMinutes() {
  return Math.floor(Math.random() * 20) + 2;
}
export function SocialProofToast() {
  const [visible, setVisible] = useState(false);
  const [buyer, setBuyer] = useState(getRandomBuyer());
  const [minutes, setMinutes] = useState(getRandomMinutes());
  useEffect(() => {
    const interval = setInterval(() => {
      setBuyer(getRandomBuyer());
      setMinutes(getRandomMinutes());
      setVisible(true);
      setTimeout(() => {
        setVisible(false);
      }, 5000);
    }, 45000);
    return () => clearInterval(interval);
  }, []);
  return <AnimatePresence data-id="element-257">
      {visible && <motion.div initial={{
      x: -100,
      opacity: 0
    }} animate={{
      x: 0,
      opacity: 1
    }} exit={{
      x: -100,
      opacity: 0
    }} transition={{
      type: 'spring',
      stiffness: 300,
      damping: 25
    }} className="fixed bottom-6 left-4 z-50 bg-white rounded-lg shadow-xl border border-gray-200 p-4 max-w-xs" data-id="element-258">
          <button onClick={() => setVisible(false)} className="absolute top-2 right-2 text-gray-400 hover:text-gray-600" aria-label="Cerrar" data-id="element-259">
            <XIcon className="w-4 h-4" data-id="element-260" />
          </button>
          <div className="flex items-start gap-3 pr-4" data-id="element-261">
            <div className="bg-[#C9A84C]/10 p-2 rounded-full flex-shrink-0" data-id="element-262">
              <ShoppingBagIcon className="w-5 h-5 text-[#C9A84C]" data-id="element-263" />
            </div>
            <div data-id="element-264">
              <div className="flex items-center gap-2" data-id="element-265">
                <p className="text-sm font-semibold text-[#1B2A4A]" data-id="element-266">
                  {buyer.name}
                </p>
                <span className="text-xs font-bold text-[#C9A84C] bg-[#C9A84C]/10 px-1.5 py-0.5 rounded" data-id="element-267">
                  $6.99
                </span>
              </div>
              <p className="text-xs text-gray-700" data-id="element-268">
                compró{' '}
                <span className="font-semibold" data-id="element-269">
                  Guía Exprés 2026 + 2 Bonos
                </span>
              </p>
              <p className="text-xs text-gray-400 mt-1" data-id="element-270">
                {buyer.city} · hace {minutes} min
              </p>
            </div>
          </div>
        </motion.div>}
    </AnimatePresence>;
}